import type { UserPayload } from '@Application/Users/Users/Actions/usersFetched';

export type PasswordResetRequestedPayload = UserPayload;

export type PasswordResetRequestedAction = {
	type: 'PASSWORD_RESET_REQUESTED';
	payload: PasswordResetRequestedPayload;
	accountId: number;
};

export default (payload: PasswordResetRequestedPayload, accountId: number): PasswordResetRequestedAction => ({
	type: 'PASSWORD_RESET_REQUESTED',
	payload,
	accountId,
});
